import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import NextBtn from './NextBtn'
import PreviousBtn from './PreviousBtn'
import ProgressBar from './ProgressBar'
import Question from './Question'

import questions from '../data/questions'
import sections from '../data/sections'
import subSections from '../data/subSections'

const QuestionPage = (props) => {
  const qId = props.match.params.qId  
  const question = questions.find((question) => qId === question.qId)
  const secId = props.match.params.secId
  const section = sections.find((section) => secId === section.secId)
  const subSecId = props.match.params.subSecId
  const subSection = subSections.find((subSection) => subSecId === subSection.subSecId)

  const questionIndexSection = section.questions.findIndex((question) => question === qId)
  const questionIndexSubSection = subSection.questions.findIndex((question) => question === qId)

  const lastQuestionSection = section.questions[section.questions.length - 1]
  const lastQuestionSubSection = subSection.questions[subSection.questions.length - 1]

  const previousDisabled = (questionIndexSection === 0)
  const previousLink = previousDisabled ? `` : `/question/${secId}/${(questionIndexSubSection === 0) ? parseInt(subSecId) - 1 : subSecId}/${section.questions[questionIndexSection - 1]}`
  const nextLink = (lastQuestionSection === qId) ? `/menu/${secId}` : (lastQuestionSubSection === qId) ? `/keyComponent/${secId}/${parseInt(subSecId) + 1}/` : `${parseInt(qId) + 1}`
  const nextLabel = (lastQuestionSection === qId) ? 'Results' : 'Next'

  useEffect(() => {
    document.getElementById("top-anchor").scrollIntoView({behavior:"smooth"})
  }, [])

  return (
    <div className="grid-container page">
      <div className="clear"></div>
      <div className="question-intro">
        <div className={`icon ${secId}-icon`} dangerouslySetInnerHTML={section.icon}></div>
        <h3 className="bold question-title">{ `${section.number}` }{ subSection.title && `${subSection.number}` }{`. ${section.title}` }{ subSection.title && `: ${subSection.title}` }</h3>
      </div>

      <div className="grid-x grid-margin-x">
        <ProgressBar currentQuestion={questionIndexSubSection + 1} totalQuestions={subSection.questions.length}/>

        <Question question={ question }></Question>

        <div className="cell small-12 large-8 large-offset-2 question-btn-box">
          <PreviousBtn previousDisabled={ previousDisabled } previousLink={ previousLink }/>
          <Link to={`/menu/${secId}`} className="btn question-btn">
              <p>Key Component Menu</p>
          </Link>
          <NextBtn nextLabel={ nextLabel } nextLink={ nextLink } />
        </div>
      </div>
    </div>
  )
}

export default QuestionPage



// WEBPACK FOOTER //
// ./src/components/QuestionPage.js